import { api } from './config/axios';
import { store } from '../store';

export const getSystemContact = () => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/contact', {}, config);
};

export const updateSystemContact = (id, payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.put(`/api/v1/admin/contact/${id}`, payload, config);
};

export const createSystemContact = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post('/api/v1/admin/contact', payload, config);
};
